module.exports = __webpack_public_path__ + "img/3.02502d45.gif";